import * as React from "react";
import { Modal, Button } from "react-bootstrap";

interface IProps {
    show: boolean,
    onSendReScreen: () => void,
    onCancel: () => void
}

class ConfirmRuleOut extends React.Component<IProps, {}> {
    handleSendReScreen = () => {
        this.props.onSendReScreen();
    }

    handleCancel = () => {
        this.props.onCancel();
    }

    render = () => {
        return (
            <>
                <Modal show={this.props.show} onHide={this.handleCancel}>
                    <Modal.Body>
                        <div>Are you sure? This will send an e-mail to donor even if ruled-out again.</div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button bsStyle='primary' onClick={this.handleSendReScreen}>Confirm</Button>
                        <Button onClick={this.handleCancel}>Cancel</Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}

export default ConfirmRuleOut;